export const PC_APPID = 'wx6b3e1b3da5cf19ab';
export const M_APPID = 'wx53b799aa586b0f97';
export const SCOPE = 'snsapi_login';
export const PlatformGuid = 'e16b0bb7-4fbb-43d3-98e9-164b8979baea';